// Этот файл сгенерирован @cian/swagger-generator
// не вносите в него ручные изменения, иначе они будут утеряны
/* eslint-disable */
import type { FetchModelResponse, IFetchModel } from '@cian/http-api';
import type { IGetMyOffersForSelectionResponseSchema } from '../../entities/get_my_offers_for_selection/GetMyOffersForSelectionResponseSchema';
import type { IErrorResponseSchema } from '../../entities/schemas/ErrorResponseSchema';

export interface IGetMyOffersForSelectionDesktopRequest {
  includeInactive?: boolean;
  limit: number;
  offset: number;
  tabType: EQueryParameters;
}

export enum EQueryParameters {
  /** Сдаю **/
  'Rent' = 'rent',
  /** Продаю **/
  'Sale' = 'sale',
}
export type TGetMyOffersForSelectionDesktopResponse =
  | FetchModelResponse<200, 'json', IGetMyOffersForSelectionResponseSchema>
  | FetchModelResponse<400, 'json', IErrorResponseSchema>;

export type TGetMyOffersForSelectionDesktopModel = IFetchModel<
  IGetMyOffersForSelectionDesktopRequest,
  undefined,
  TGetMyOffersForSelectionDesktopResponse
>;

export interface IMappers<TResponse200, TResponse400> {
  200(response: IGetMyOffersForSelectionResponseSchema, headers: Headers): TResponse200;
  400(response: IErrorResponseSchema, headers: Headers): TResponse400;
}
